module.exports = __webpack_public_path__ + "static/media/qr-scanner_function-3.159edb2b.png";